module.exports = __webpack_public_path__ + "static/buying-bg-3bc5ee3f786bd5196f4d8e78de2d3db4.jpg";